import { render, staticRenderFns } from "./SidebarNavProfile.vue?vue&type=template&id=4a7f73f2&"
import script from "./SidebarNavProfile.vue?vue&type=script&lang=js&"
export * from "./SidebarNavProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports